import { defineMessages } from 'react-intl';

export default defineMessages({
  copyright: {
    id: 'All content on this site is published under license {license}.',
    defaultMessage:
      'All content on this site is published under license {license}.',
  },
  license: {
    id: 'Creative Commons Attribution-NoDerivs 3.0 Unported',
    defaultMessage: 'Creative Commons Attribution-NoDerivs 3.0 Unported',
  },
  resetCookies: {
    id: 'Reset Cookies',
    defaultMessage: 'Reset Cookies',
  },
  socialNetworks: {
    id: 'Social networks',
    defaultMessage: 'Social networks',
  },
  siteMap: {
    id: 'Site map',
    defaultMessage: 'Site map',
  },
});
